/**
 * Generates display parts for operation codes with dynamic segments
 *
 * Example:
 * - 3 chunks separated by dash ("-"):
 *
 * Input: VBK-LKCN-ATTP
 * ->
 * [VBK] [LKCN] [ATTP]
 *
 * - 4 chunks separated by dash ("-"):
 *
 * Input: VBK-LKCN-N-ATTP
 * ->
 * [VBK-LKCN] [N] [ATTP]
 *
 * - 5 chunks separated by dash ("-"):
 *
 * Input: VBK-NBBINKABC-LKCN-N-ATTP
 * ->
 * [VBK-NBBINKABC] [LKCN] [N-ATTP]
 *
 */
export const generateDisplayParts = (operationCode: string): string[] => {
  const parts = operationCode.split('-');
  const partsCount = parts.length;

  if (partsCount > 4) {
    const firstSection = parts.slice(0, 2).join('-');
    const middleSection = parts[2];
    const lastSection = parts.slice(3).join('-');
    return [firstSection, middleSection, lastSection];
  } else if (partsCount > 3) {
    const firstSection = parts.slice(0, 2).join('-');
    const middleSection = parts[2];
    const lastSection = parts.slice(3).join('-');
    return [firstSection, middleSection, lastSection];
  } else {
    return parts;
  }
};
